import React, { Component } from "react";
import {
  Routes,
  Route,
  //useNavigate,
} from "react-router-dom";
import Logo from "./components/Logo";
//import Search from "./components/Search";
import Navigation from "./components/Navigation";
import Content from "./components/Content";
import NotFoundPage from "./components/NotFoundPage";
import OverviewView from "./views/overview";
import SolutionsView from "./views/solutions";
//import { getNavigationLevel1, getTestCollection } from "./services";
//import { butter } from "./services/axios-setup";
import { formatUrl, deformatUrl } from "./util/format-url";
import Viewer from "react-viewer";
//import ThemeMode from "./components/ThemeMode";
import Fuse from "fuse.js";
import Topbar from "./components/Topbar";
import hljs from "highlight.js";
import "highlight.js/styles/default.css"; // Import the default Highlight.js style
//import "highlight.js/styles/github.css";
//import "highlight.js/styles/atom-one-light.min.css";
//import "highlight.js/styles/intellij-light.min.css";
//import "highlight.js/styles/monokai.min.css";
import "highlight.js/styles/nnfx-light.min.css";
//import "highlight.js/styles/stackoverflow-light.min.css";
//import "highlight.js/styles/vs.min.css";
//import "./styles/code/tomorrow-light.css";
//import "./styles/code/hemisu-light.css";

import python from "highlight.js/lib/languages/python";
import terraform from "./terraform";
import bash from "highlight.js/lib/languages/bash";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";

const butter = require("buttercms")(
  process.env.REACT_APP_BUTTERCMS_TOKEN,
  false,
  80000
);

// Register highlight.js languages
hljs.registerLanguage("python", python);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("terraform", terraform);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("json", json);

const notFoundOptions = {
  includeScore: true,
  shouldSort: true,
  minMatchCharLength: 2,
  // threshold: 0.6,
  //keys: ["name", "content"],
  keys: ["name"],
};

interface Props {}

interface State {
  loading: boolean;
  loadingError: string;
  pages: any;
  activeTitle: string;
  activeContent: any;
  navList: any;
  pagesContent: any;
  imgFullscreenState: boolean;
  imgFullscreenSrc: string;
  notFoundUrl: string;
  isDarkMode: boolean;
  notFoundSuggestions: any;
  mobileMainMenuOpen: boolean;
}

class App extends Component<Props, State> {
  state = {
    loading: true,
    loadingError: "",
    pages: [],
    activeTitle: "Core Concepts",
    activeContent: "",
    navList: [],
    pagesContent: [],
    imgFullscreenState: false,
    imgFullscreenSrc: "",
    notFoundUrl: "",
    isDarkMode: false,
    notFoundSuggestions: [],
    mobileMainMenuOpen: false,
  };

  componentDidMount() {
    //const browserUrl: string = window.location.href ? window.location.href : "";
    const browserPathname: string = window.location.pathname
      ? window.location.pathname
      : "";
    //console.log("browserUrl", browserUrl, "browserPathname", browserPathname);
    this.loadNavigation()
      .then((navigationRes: any) => {
        //console.log("navigationRes", navigationRes);
        this.setState(
          {
            navList: navigationRes,
          },
          () => {
            var filterKey: string = "";
            var filterValue: any = "";
            var groupName: string = "";
            var subgroupName: string = "";
            var pageName: string = "";
            if (browserPathname !== "/") {
              filterKey = "fields.name";
              var browserPathname_arr: any = browserPathname.split("/");
              //console.log("browserPathname_arr", browserPathname_arr);
              if (browserPathname_arr.length === 3) {
                groupName = browserPathname_arr[1]
                  ? browserPathname_arr[1]
                  : "";
                pageName = browserPathname_arr[browserPathname_arr.length - 1]
                  ? browserPathname_arr[browserPathname_arr.length - 1]
                  : "";
                navigationRes.forEach((group: any) => {
                  var groupUrlFormat: string = formatUrl(group.name);
                  if (groupUrlFormat === groupName) {
                    group.items.forEach((page: any) => {
                      var pageUrlFormat: string = formatUrl(page.name);
                      if (pageUrlFormat === pageName) {
                        filterValue = page.name;
                      }
                    });
                  }
                });
              } else {
                groupName = browserPathname_arr[1]
                  ? browserPathname_arr[1]
                  : "";
                subgroupName = browserPathname_arr[2]
                  ? browserPathname_arr[2]
                  : "";
                navigationRes.forEach((group: any) => {
                  var groupUrlFormat: string = formatUrl(group.name);
                  if (groupUrlFormat === groupName) {
                    groupName = group.name;
                    group.items.forEach((page: any) => {
                      var pageUrlFormat: string = formatUrl(page.name);
                      if (pageUrlFormat === subgroupName) {
                        subgroupName = page.name;
                      }
                    });
                  }
                });
                pageName = browserPathname_arr[browserPathname_arr.length - 1]
                  ? browserPathname_arr[browserPathname_arr.length - 1]
                  : "";
              }
              pageName = deformatUrl(pageName);
              /*console.log(
                "groupName",
                groupName,
                "subgroupName",
                subgroupName,
                "pageName",
                pageName
              );*/
            } else {
              filterKey = "fields.homepage";
              filterValue = true;
            }
            //console.log("filterKey", filterKey, "filterValue", filterValue);
            this.loadContent(
              navigationRes,
              filterKey,
              filterValue,
              groupName,
              subgroupName,
              pageName
            )
              .then((contentRes: any) => {
                //console.log("contentRes.pages", contentRes.pages);
                this.setState(
                  {
                    pages: contentRes.pages,
                    navList: contentRes.nav,
                    loading: false,
                    //activeTitle: contentRes.pages[0].name,
                    activeTitle: pageName,
                    activeContent: contentRes.pages[0].content,
                  },
                  () => {
                    this.checkUrl(contentRes.pages);
                  }
                );
              })
              .catch((err: any) => {
                //console.log("get content err...", err);
                this.setState(
                  {
                    loading: false,
                    //loadingError: "Something went wrong! Content not loaded",
                  },
                  () => {
                    this.checkUrl(navigationRes);
                  }
                );
              });
          }
        );
      })
      .catch((err: any) => {
        //console.log("err", err);
        this.setState({
          loading: false,
          loadingError: "Something went wrong! Navigation not loaded",
        });
      });
    this.highlightCode();
  }

  componentDidUpdate() {
    this.highlightCode();
  }

  /**
   * Highlight code blocks in the content.
   * In ButterCMS, setting code block languages will map to the following languages:
   * - Python: Python
   * - C++: Bash
   * - C#: Terraform
   * - C: JSON
   */
  highlightCode() {
    const pythonNodes = document.querySelectorAll("pre.language-python code");
    const bashNodes = document.querySelectorAll("pre.language-cpp code");
    const javascriptNodes = document.querySelectorAll(
      "pre.language-javascript code"
    );
    const jsonNodes = document.querySelectorAll("pre.language-c code");
    const terraformNodes = document.querySelectorAll(
      "pre.language-csharp code"
    );

    pythonNodes.forEach((node: any) => {
      const code = node.textContent;
      const result = hljs.highlight(code, { language: "python" });
      node.innerHTML = result.value;
      node.className = `hljs ${result.language}`;
    });

    bashNodes.forEach((node: any) => {
      const code = node.textContent;
      const result = hljs.highlight(code, { language: "bash" });
      node.innerHTML = result.value;
      node.className = `hljs ${result.language}`;
    });

    terraformNodes.forEach((node: any) => {
      const code = node.textContent;
      const result = hljs.highlight(code, { language: "terraform" });
      node.innerHTML = result.value;
      node.className = `hljs ${result.language}`;
    });

    javascriptNodes.forEach((node: any) => {
      const code = node.textContent;
      const result = hljs.highlight(code, { language: "javascript" });
      node.innerHTML = result.value;
      node.className = `hljs ${result.language}`;
    });

    jsonNodes.forEach((node: any) => {
      const code = node.textContent;
      const result = hljs.highlight(code, { language: "json" });
      node.innerHTML = result.value;
      node.className = `hljs ${result.language}`;
    });
  }

  handleMobileMainMenuClick = () => {
    if (this.state.mobileMainMenuOpen) {
      this.setState({
        mobileMainMenuOpen: false,
      });
    } else {
      this.setState({
        mobileMainMenuOpen: true,
      });
    }
  };
  checkUrl = (pages: any) => {
    let winUrl: string = window.location.pathname;
    //console.log("winUrl", winUrl);
    if (winUrl) {
      winUrl = winUrl.substring(1);
      if (pages && pages.length > 0) {
        //console.log("pages", pages);
        let pageFilter: any = pages.filter((page: any) => page.url === winUrl);
        if (pageFilter[0]) {
          this.getPageContent(pageFilter[0].name, pageFilter[0].content);
        } else {
          this.setState(
            {
              notFoundUrl: winUrl,
            },
            () => {
              //console.log("pages", pages);
              var menuItems: any = [];
              pages.forEach((group: any) => {
                if (group.items) {
                  group.items.forEach((menuItem: any) => {
                    menuItems.push(menuItem);
                  });
                }
              });
              //console.log("menuItems", menuItems);
              const fuse = new Fuse(menuItems, notFoundOptions);
              const result = fuse.search(winUrl);
              var tempResults: any = [];
              //console.log("result", result);
              if (result && result.length > 0) {
                let maxSuggestions: number = 0;
                result.forEach((r: any) => {
                  if (r.item.name && r.item.menu_group && maxSuggestions < 10) {
                    var url: string = `/${formatUrl(
                      r.item.menu_group.name
                    )}/${formatUrl(r.item.name)}`;
                    var tempItem: any = {
                      url: url,
                      name: r.item.name,
                      content: "",
                      //content: r.item.content,
                    };
                    tempResults.push(tempItem);
                    maxSuggestions++;
                  }
                });
                //console.log("notFoundSuggestions", tempResults);
                this.setState({
                  notFoundSuggestions: tempResults,
                });
              }
            }
          );
        }
      } else {
        this.setState({
          notFoundUrl: winUrl,
        });
      }
    }
  };
  loadContent = (
    navData: any,
    filterKey: any,
    filterValue: any,
    groupName?: string,
    subgroupName?: string,
    pageName?: string
  ): Promise<object> => {
    /*console.log(
      "loadContent",
      navData,
      filterKey,
      filterValue,
      groupName,
      subgroupName,
      pageName
    );*/
    var pages: any = [];
    const promise = new Promise<object>((resolve, reject) => {
      if (groupName && subgroupName) {
        /*console.log(
          "groupName",
          groupName,
          "subgroupName",
          subgroupName,
          "pageName",
          pageName
        );*/
        //groupName = groupName.charAt(0).toUpperCase() + groupName.slice(1);
        groupName = deformatUrl(groupName);
        butter.content
          .retrieve(["page"], {
            "fields.url_group.name": groupName,
            "fields.url_subgroup.name": subgroupName,
            //"fields.name": pageName,
          })
          .then(function (resp: any) {
            let pagesTemp: any = resp.data.data.page ? resp.data.data.page : [];
            //console.log("pagesTemp", pagesTemp);
            if (pagesTemp) {
              pagesTemp.forEach((page: any) => {
                /*var pageUrlFormat: string = formatUrl(page.name);
                        if (pageUrlFormat === pageName) {
                          //console.log("found page", page);
                        }*/
                var pageUrl: string = "";
                let urlGroup: string = page.url_group.name
                  ? page.url_group.name
                  : "";
                let urlSubGroup: string = page.url_subgroup.name
                  ? page.url_subgroup.name
                  : "";
                let pageNameTemp: string = page.menu_item.name
                  ? page.menu_item.name
                  : "";
                if (urlGroup) {
                  pageUrl += formatUrl(urlGroup) + "/";
                }
                if (urlSubGroup) {
                  pageUrl += formatUrl(urlSubGroup) + "/";
                }
                if (page?.ml_group) {
                  pageUrl += formatUrl(page?.ml_group) + "/";
                }
                if (pageNameTemp) {
                  pageUrl = formatUrl(pageNameTemp);
                } else {
                  pageUrl += formatUrl(page.name);
                }
                navData.forEach((menu_group: any) => {
                  if (menu_group.name === urlGroup) {
                    menu_group.items.forEach((menu_item: any) => {
                      if (menu_item.name === urlSubGroup) {
                        if (!menu_item.subitems) {
                          menu_item["subitems"] = [];
                        }
                        menu_item.subitems.push(page);
                        return menu_item;
                      }
                    });
                    return menu_group;
                  }
                });
                var pageData: any = {
                  name: page.name,
                  content: page.content,
                  url: pageUrl,
                  homepage: page.homepage,
                  group: urlGroup,
                  subgroup: urlSubGroup,
                  ml_group: page?.ml_group,
                };
                //console.log("pageData", pageData);
                pages.push(pageData);
              });
              resolve({ pages: pages, nav: navData });
            } else {
              reject("No content found!");
            }
          })
          .catch((err: any) => {
            //console.log("err", err);
            reject("No content found!");
          });
      } else if (groupName) {
        //groupName = groupName.charAt(0).toUpperCase() + groupName.slice(1);
        groupName = deformatUrl(groupName);
        butter.content
          .retrieve(["page"], {
            "fields.url_group.name": groupName,
            //"fields.url_subgroup.name": subgroupName,
          })
          .then(function (resp: any) {
            let pagesTemp: any = resp.data.data.page ? resp.data.data.page : [];
            //console.log("pagesTemp", pagesTemp);
            if (pagesTemp) {
              pagesTemp.forEach((page: any) => {
                /*var pageUrlFormat: string = formatUrl(page.name);
                        if (pageUrlFormat === pageName) {
                          //console.log("found page", page);
                        }*/
                var pageUrl: string = "";
                let urlGroup: string = page.url_group.name
                  ? page.url_group.name
                  : "";
                let urlSubGroup: string = page.url_subgroup.name
                  ? page.url_subgroup.name
                  : "";
                let pageNameTemp: string = page.menu_item.name
                  ? page.menu_item.name
                  : "";
                if (urlGroup) {
                  pageUrl += formatUrl(urlGroup) + "/";
                }
                if (urlSubGroup) {
                  pageUrl += formatUrl(urlSubGroup) + "/";
                }
                if (page?.ml_group) {
                  pageUrl += formatUrl(page?.ml_group) + "/";
                }
                if (pageNameTemp) {
                  pageUrl = formatUrl(pageNameTemp);
                } else {
                  pageUrl += formatUrl(page.name);
                }
                navData.forEach((menu_group: any) => {
                  if (menu_group.name === urlGroup) {
                    menu_group.items.forEach((menu_item: any) => {
                      if (menu_item.name === urlSubGroup) {
                        if (!menu_item.subitems) {
                          menu_item["subitems"] = [];
                        }
                        menu_item.subitems.push(page);
                        return menu_item;
                      }
                    });
                    return menu_group;
                  }
                });
                var pageData: any = {
                  name: page.name,
                  content: page.content,
                  url: pageUrl,
                  homepage: page.homepage,
                  group: urlGroup,
                  subgroup: urlSubGroup,
                  ml_group: page?.ml_group,
                };
                pages.push(pageData);
              });
              resolve({ pages: pages, nav: navData });
            } else {
              reject("No content found!");
            }
          })
          .catch((err: any) => {
            //console.log("err", err);
            reject("No content found!");
          });
      } else {
        butter.content
          .retrieve(["page"], { [filterKey]: filterValue })
          .then(function (resp: any) {
            let pagesTemp: any = resp.data.data.page ? resp.data.data.page : [];
            //console.log("pagesTemp", pagesTemp);
            if (pagesTemp) {
              pagesTemp.forEach((page: any) => {
                var pageUrl: string = "";
                let urlGroup: string = page.url_group.name
                  ? page.url_group.name
                  : "";
                let urlSubGroup: string = page.url_subgroup.name
                  ? page.url_subgroup.name
                  : "";
                let pageNameTemp: string = page.menu_item.name
                  ? page.menu_item.name
                  : "";
                if (urlGroup) {
                  pageUrl += formatUrl(urlGroup) + "/";
                }
                if (urlSubGroup) {
                  pageUrl += formatUrl(urlSubGroup) + "/";
                }
                if (page?.ml_group) {
                  pageUrl += formatUrl(page?.ml_group) + "/";
                }
                if (pageNameTemp) {
                  pageUrl = formatUrl(pageNameTemp);
                } else {
                  pageUrl += formatUrl(page.name);
                }
                navData.forEach((menu_group: any) => {
                  if (menu_group.name === urlGroup) {
                    menu_group.items.forEach((menu_item: any) => {
                      if (menu_item.name === urlSubGroup) {
                        if (!menu_item.subitems) {
                          menu_item["subitems"] = [];
                        }
                        menu_item.subitems.push(page);
                        return menu_item;
                      }
                    });
                    return menu_group;
                  }
                });
                var pageData: any = {
                  name: page.name,
                  content: page.content,
                  url: pageUrl,
                  homepage: page.homepage,
                  group: urlGroup,
                  subgroup: urlSubGroup,
                };
                pages.push(pageData);
              });
              resolve({ pages: pages, nav: navData });
            } else {
              reject("No content found!");
            }
          })
          .catch((err: any) => {
            //console.log("err", err);
            reject("No content found!");
          });
      }
    });
    return promise;
  };
  loadNavigation = (): Promise<object> => {
    var navList: any = [];
    const promise = new Promise<object>((resolve, reject) => {
      butter.content
        .retrieve(["menu_group"], {})
        .then(function (resp: any) {
          //console.log("resp", resp);
          let menuGroup: any = resp.data.data.menu_group
            ? resp.data.data.menu_group
            : [];
          if (menuGroup) {
            menuGroup.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
            butter.content
              .retrieve(["menu_item"], {})
              .then(function (resp2: any) {
                let menuItem: any = resp2.data.data.menu_item
                  ? resp2.data.data.menu_item
                  : [];
                if (menuItem) {
                  menuGroup.forEach((mGroup: any) => {
                    var tempMenuItem: any = menuItem.filter((mItem: any) => {
                      return mItem.menu_group.name === mGroup.name;
                    });
                    if (tempMenuItem && tempMenuItem.length > 0) {
                      tempMenuItem.sort((a: any, b: any) =>
                        a.order > b.order ? 1 : -1
                      );
                    }
                    var rootPage: string =
                      mGroup.page && mGroup.page.length > 0
                        ? formatUrl(mGroup.page[0].name)
                        : "";
                    var tempMenu: any = {
                      name: mGroup.name,
                      icon: mGroup.icon,
                      order: mGroup.order,
                      hide: mGroup.hide,
                      page: rootPage,
                      items: tempMenuItem,
                    };
                    navList.push(tempMenu);
                  });
                  resolve(navList);
                } else {
                  reject("No Menu item data found!");
                }
              })
              .catch(function (err: any) {
                reject(
                  "Something went wrong! No Navigation menu items data found!"
                );
              });
          } else {
            reject("No Main menu data found!");
          }
        })
        .catch(function (err: any) {
          //console.log("err", err);
          reject("Something went wrong! No Navigation menu data found!");
        });
    });
    return promise;
  };
  getPageContent(name: string, content: any) {
    //console.log("getPageContent", name, content);
    this.setState({
      activeTitle: name,
      activeContent: content,
    });
  }
  handleSelectMenuGroup(group: any, menuItem: string, navigateFunc: Function) {
    //console.log("handleSelectMenuGroup", group, menuItem);
    this.setState({
      loading: true,
    });
    this.loadContent(this.state.navList, "fields.name", menuItem)
      .then((contentRes: any) => {
        //console.log("contentRes.pages[0]", contentRes.pages[0]);
        this.setState(
          {
            pages: contentRes.pages,
            loading: false,
            activeTitle: menuItem,
            activeContent: contentRes.pages[0],
          },
          () => {
            this.checkUrl(this.state.navList);
            navigateFunc(group, menuItem);
            //navigate(`/${formatUrl(group.name)}/${formatUrl(menuItem)}`);
          }
        );
      })
      .catch((err: any) => {
        //console.log("get content err...", err);
        this.setState({
          loading: false,
          loadingError: "Something went wrong! Content not loaded",
        });
      });
    /*this.setState({
      activeTitle: menuItem,
      activeContent: content,
    });*/
  }
  handleTableContentClick(
    group: any,
    pageName: string,
    pageType: string,
    navigateFunc: Function
  ) {
    //console.log("handleTableContentClick", group, pageName, pageType);
    this.setState({
      loading: true,
    });
    this.loadContent(this.state.navList, "fields.name", pageName)
      .then((contentRes: any) => {
        //console.log("contentRes.pages[0]", contentRes.pages[0], pageName);
        this.setState(
          {
            pages: contentRes.pages,
            loading: false,
            activeTitle: pageName,
            activeContent: contentRes.pages[0],
          },
          () => {
            this.checkUrl(this.state.navList);
            navigateFunc(group, pageName);
            //navigate(`/${formatUrl(group.name)}/${formatUrl(menuItem)}`);
          }
        );
      })
      .catch((err: any) => {
        //console.log("get content err...", err);
        this.setState({
          loading: false,
          loadingError: "Something went wrong! Content not loaded",
        });
      });
    /*var pagesCopy: any = [...this.state.pages];
    var pageContent: any = pagesCopy.filter((page: any) => {
      return page.name === name;
    });
    if (pageContent[0]) {
      this.setState({
        activeTitle: name,
        activeContent: pageContent[0],
      });
    }*/
  }
  handleContentClick(e: any) {
    if (e.target.tagName === "IMG") {
      this.setState({
        imgFullscreenSrc: e.target.src,
        imgFullscreenState: true,
      });
    }
  }
  handleCloseFullscreenImg() {
    this.setState({
      imgFullscreenSrc: "",
      imgFullscreenState: false,
    });
  }
  handleChangeTheme() {
    const { isDarkMode } = this.state;
    if (isDarkMode) {
      this.setState({ isDarkMode: false });
    } else {
      this.setState({ isDarkMode: true });
    }
  }
  render() {
    var {
      pages,
      activeTitle,
      //activeContent,
      navList,
      pagesContent,
      loading,
      loadingError,
      imgFullscreenSrc,
      imgFullscreenState,
      notFoundUrl,
      isDarkMode,
      notFoundSuggestions,
    } = this.state;
    let introContent: string = "-";
    //let introGroup: string = "";
    //let introSubgroup: string = "";
    if (
      !loading &&
      pages &&
      pages.length > 0 &&
      navList &&
      navList.length > 0
    ) {
      var tempIntro: any = pages.filter((page: any) => page.homepage);
      if (tempIntro && tempIntro[0]) {
        introContent = tempIntro[0].content;
        //introGroup = tempIntro[0].group;
        //introSubgroup = tempIntro[0].subgroup;
      }
    }
    let activeTheme: string = isDarkMode ? "dark" : "light";
    const pathname = window.location.pathname; //returns the current url minus the domain name
    var footerClass: string = "default-footer";
    var isDocumentationPage: boolean = false;
    if (
      pathname === "/" ||
      pathname === "/overview" ||
      pathname === "/solutions"
    ) {
      footerClass = "custom-footer";
    } else {
      isDocumentationPage = true;
    }
    /*console.log(
      "pathname",
      pathname,
      "mobileMainMenuOpen",
      this.state.mobileMainMenuOpen
    );*/
    /*console.log(
      "pages",
      pages,
      "navList",
      navList,
      "introContent",
      introContent,
      navList,
      pathname,
      activeTitle,
      activeContent
    );*/
    return (
      <div className="main" data-theme={activeTheme}>
        <div className="main-inner">
          {loading ? (
            <div className="message overflow">
              <Logo isDarkMode={isDarkMode} />
              <div className="box loading">Loading...</div>
            </div>
          ) : loadingError ? (
            <div className="message overflow">
              <Logo isDarkMode={isDarkMode} />
              <div className="box error">{loadingError}</div>
            </div>
          ) : (
            <>
              {navList && navList.length > 0 ? (
                <>
                  <Topbar
                    isDarkMode={isDarkMode}
                    pages={navList}
                    mobileMainMenuOpen={this.state.mobileMainMenuOpen}
                    handleMobileMainMenuClick={() =>
                      this.handleMobileMainMenuClick()
                    }
                  />
                  {pathname !== "/" &&
                    pathname !== "/overview" &&
                    pathname !== "/solutions" && (
                      <nav
                        className={`nav ${
                          isDocumentationPage && this.state.mobileMainMenuOpen
                            ? "mob-menu-is-open"
                            : ""
                        }`}
                      >
                        {/* <Logo isDarkMode={isDarkMode} /> */}
                        {/* <Search
                      pages={navList}
                      selectSearch={(name: string, content: any) =>
                        this.getPageContent(name, content)
                      }
                    /> */}
                        <div className="menu">
                          <Navigation
                            activatePageTitle={activeTitle}
                            navList={navList}
                            pages={pages}
                            pagesContent={pagesContent}
                            isDarkMode={isDarkMode}
                            handleSelectMenuGroup={(
                              group: string,
                              menuItem: string,
                              navigateFunc: Function
                            ) =>
                              this.handleSelectMenuGroup(
                                group,
                                menuItem,
                                navigateFunc
                              )
                            }
                          />
                        </div>
                        {/* <ThemeMode
                      isDarkMode={isDarkMode}
                      handleChangeTheme={() => this.handleChangeTheme()}
                    /> */}
                      </nav>
                    )}
                  <>
                    {introContent && (
                      <Routes>
                        <Route
                          path="*"
                          element={
                            <NotFoundPage
                              url={notFoundUrl}
                              suggestions={notFoundSuggestions}
                            />
                          }
                        />
                        <Route
                          path={`/`}
                          element={
                            <OverviewView navList={navList} pages={pages} />
                          }
                        />
                        <Route
                          path="/overview"
                          element={
                            <OverviewView navList={navList} pages={pages} />
                          }
                        />
                        {pages.map((page: any) => {
                          return (
                            <Route
                              index={page.Name === "Core Concepts"}
                              key={"page-" + page}
                              path={`${page.url}`}
                              element={
                                <Content
                                  name={page.name}
                                  content={page.content}
                                  group={page.group}
                                  subgroup={page.subgroup}
                                  activatePageTitle={activeTitle}
                                  navList={navList}
                                  handleContentClick={(e: any) =>
                                    this.handleContentClick(e)
                                  }
                                  handleTableContentClick={(
                                    group: any,
                                    page: string,
                                    pageType: string,
                                    navigateFunc: Function
                                  ) =>
                                    this.handleTableContentClick(
                                      group,
                                      page,
                                      pageType,
                                      navigateFunc
                                    )
                                  }
                                />
                              }
                            />
                          );
                        })}
                        <Route
                          path="/solutions"
                          element={
                            <SolutionsView navList={navList} pages={pages} />
                          }
                        />
                      </Routes>
                    )}
                  </>
                </>
              ) : (
                <div className="no-data">No Documentation</div>
              )}
              <div className="break"></div>
              <footer className={`footer-wrap ${footerClass}`}>
                <div className="footer-wrap-inner">
                  <div className="footer-wrap-inner-left">
                    <a
                      href="https://ikigailabs.medium.com/"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Blog
                    </a>
                    <a
                      href="https://www.ikigailabs.io/resources-library"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Resource Library
                    </a>
                    <a
                      href="https://www.ikigailabs.io/terms-of-use"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Terms of Use
                    </a>
                  </div>
                  <div className="footer-wrap-inner-right">
                    <span>
                      &copy; {new Date().getFullYear()}, Ikigai Labs Inc.
                    </span>
                  </div>
                </div>
              </footer>
              <Viewer
                visible={imgFullscreenState}
                onClose={() => this.handleCloseFullscreenImg()}
                images={[
                  {
                    src: imgFullscreenSrc,
                    alt: "IkigaiLabs Documentation",
                  },
                ]}
                className="img-viewer"
                noFooter={true}
                drag={false}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}

export default App;
